<template>
  <div class="noWrap">
    <span>{{ payload.text }}</span>
  </div>
</template>

<script>
import DataTableChipColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableChipColumn.vue';
import StatementOperationType from 'Modules/contacard/reports/statements/components/StatementOperationType';

export default {
  name: 'StatementOperationTypeColumn',
  extends: DataTableChipColumnVue,
  data: (vm) => ({
    status: vm.handleStatus(StatementOperationType),
  }),
};
</script>
